module.exports = __webpack_public_path__ + "static/media/linkedin.8848354c.jpg";